export enum CalendarUpdateInitiationTypeEnum {
    dateChange = 'DATE_CHANGE',
    pushNotification = 'PUSH_NOTIFICATION',
    pullToRefresh = 'PULL_TO_REFRESH'
}
